import { z } from 'zod';
import { cursorQuerySchema, paginated, uuidSchema } from './common.js';
export const auditLogEntrySchema = z.object({
    id: uuidSchema,
    actorId: uuidSchema.nullable(),
    actorName: z.string().nullable(),
    action: z.string(),
    entityType: z.string(),
    entityId: uuidSchema.nullable(),
    ip: z.string().nullable(),
    metadata: z.record(z.string(), z.unknown()),
    createdAt: z.string(),
});
export const auditLogListResponseSchema = paginated(auditLogEntrySchema);
export const auditLogQuerySchema = cursorQuerySchema.extend({
    action: z.string().optional(),
    actorId: uuidSchema.optional(),
});
//# sourceMappingURL=audit.js.map